import { DownloadBlob } from '@browser/Browser';
import * as rt from "@common/AppRT";
import { strCompareLowerCase } from "@common/Common";
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';
import { CriterionDetailsDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionDetailsDialog';
import CriterionDetailsDialog from "@Criteria/Hierarchies/Components/CriterionDetailsDialog.vue";
import { CriterionReadModel } from "@Criteria/Hierarchies/Domain/readmodels";
import { IEvaluationCommand } from "@Evaluation/cqrs";
import { CriteriaSurveyAccessLinksViewModel } from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyAccessLinks';
import CriteriaSurveyAccessLinks from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyAccessLinks.vue';
import { CriteriaSurveyEmailSenderViewModel } from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyEmailSender';
import CriteriaSurveyEmailSender from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyEmailSender.vue';
import DisagreementsReportDialog from "@Evaluation/CriteriaSurveys/Components/DisagreementsReportDialog.vue";
import MeetingQuestionReview from "@Evaluation/CriteriaSurveys/Components/MeetingQuestionReview.vue";
import MeetingStarterDialog from "@Evaluation/CriteriaSurveys/Components/MeetingStarterDialog.vue";
import MeetingStopperDialog from "@Evaluation/CriteriaSurveys/Components/MeetingStopperDialog.vue";
import PanelConsistencyAnalysisDialog from "@Evaluation/CriteriaSurveys/Components/PanelConsistencyAnalysisDialog.vue";
import SurveyCloserDialog from "@Evaluation/CriteriaSurveys/Components/SurveyCloserDialog.vue";
import SurveyOpenerDialog from "@Evaluation/CriteriaSurveys/Components/SurveyOpenerDialog.vue";
import { SavePanelVoteCommandV1, SendEmailCommandV1, StartSurveyCommandV1, StopSurveyCommandV1 } from "@Evaluation/CriteriaSurveys/Domain/commands-core";
import CriteriaSurveyCommands from '@Evaluation/CriteriaSurveys/Domain/commands-vue-component';
import CriteriaSurveysQueries from '@Evaluation/CriteriaSurveys/Domain/queries-vue-component';
import { CriteriaDownloadAccessLinksReadModel, CriteriaQuestionsBrowserItemReadModel, CriteriaSurveyPanelistsReadModel, MeetingManagerPageReadModel, MeetingQuestionReviewReadModel, PanelConsistencyAnalysisReadModel, PanelDisagreementsReportReadModel } from "@Evaluation/CriteriaSurveys/Domain/readmodels";
import { SurveyVoteStatus } from "@Evaluation/Model";
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioOrDecisionNavigation, MeetingQuestionReview, MeetingStarterDialog, MeetingStopperDialog, DisagreementsReportDialog,
        SurveyOpenerDialog, SurveyCloserDialog, PanelConsistencyAnalysisDialog, CriterionDetailsDialog, CriteriaSurveyAccessLinks, CriteriaSurveyEmailSender
    }
})
export default class MeetingManagerPage extends mixins(CriteriaSurveysQueries, CriteriaSurveyCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId() { return Number.parseInt(this.$route.params.projectId); }
    get evalModelId() { return Number.parseInt(this.$route.params.evalModelId); }
    get surveyId() { return Number.parseInt(this.$route.params.surveyId); }

    handler: any = null;
    SavingCommentHandle: any = null;
    SwitchQuestionDebounceHandle: any = null;
    SearchPhrase: string = null;
    initialized: boolean = false;
    criterionDetailsDialog: CriterionDetailsDialogViewModel = new CriterionDetailsDialogViewModel();

    rm: MeetingManagerPageReadModel = null;
    get Name(): string { return this.rm?.SurveyName; }
    get QuestionsCount(): number { return this.rm?.SurveyQuestionsCount; }
    get SurveyStarted(): boolean { return this.rm?.SurveyStarted; }

    get disagreementReport(): PanelDisagreementsReportReadModel { return this.rm?.DisagreementReport; }
    get consistencyAnalysis(): PanelConsistencyAnalysisReadModel { return this.rm?.ConsistencyAnalysis; }

    get url_Criteria_WeightsPage() { return dynamicUiRoutes.Criteria_WeightsPage(this.$route, this.workspaceId, this.projectId, this.evalModelId); }


    meetingStarterOpened: boolean = false;
    meetingStopperOpened: boolean = false;
    disagreementsReportOpened: boolean = false;
    consistencyAnalysisOpened: boolean = false;
    surveyOpenerOpened: boolean = false;
    surveyCloserOpened: boolean = false;

    MeetingStarted: boolean = false;
    AutoRevealEnabled: boolean = false;
    NamesRevealed: boolean = true;
    VotesRevealed: boolean = false;

    CurrentContext: CriterionReadModel = null;
    EvalContexts: CriterionReadModel[] = [];
    CurrentQuestionId: string = null;

    criteriaSurveyAccessLinks: CriteriaSurveyAccessLinksViewModel = new CriteriaSurveyAccessLinksViewModel();
    criteriaSurveyEmailSender: CriteriaSurveyEmailSenderViewModel = new CriteriaSurveyEmailSenderViewModel();   

    get Question() { return this.rm?.Question; }
    get Questions(): CriteriaQuestionsBrowserItemReadModel[] { return this.rm.Questions; }

    get EvalContextsView(): CriterionReadModel[] 
    {
        const phrase = this.SearchPhrase?.toLowerCase() ?? "";
        return this.EvalContexts.filter(o => o.Path.toLowerCase().indexOf(phrase) >= 0);
    }

    get QuestionsView(): CriteriaQuestionsBrowserItemReadModel[] 
    {
        return this.Questions
            .filter(q => q.ContextCriterionId === this.CurrentContext.CriterionId)
            .sort((a, b) => compareQuestions(a, b));
    }

    get AllQuestionsAnswered(): boolean { return !this.Questions.some(a => a.Status === SurveyVoteStatus.Empty); }

    get AnsweredQuestionsCount(): number { return this.Questions.filter(a => a.Status !== SurveyVoteStatus.Empty).length; }

    getQuestionCssClass(q: CriteriaQuestionsBrowserItemReadModel)
    {
        switch (q.Status)
        {
            case SurveyVoteStatus.Empty:
                return 'fa fa-question-circle fg-color-red';
            case SurveyVoteStatus.Agg:
                return 'fa fa-check-circle fg-color-green';
            case SurveyVoteStatus.Manual:
                return 'fa fa-check-circle fg-color-orange';
            default:
                return 'fa';
        }
    }



    SetCurrentContext(criterionId: number)
    {
        if (this.CurrentContext == null || this.CurrentContext.CriterionId !== criterionId)
        {
            const evalContext = this.EvalContexts.find(ec => ec.CriterionId === criterionId);

            this.CurrentContext = evalContext;
        }
    }

    SetCurrentQuestion(questionId: string)
    {
        const q = this.Questions.find(a => a.QuestionId === questionId);

        if (q)
        {
            this.CurrentQuestionId = questionId;
            //this.CurrentQuestionOrderValue = this.Questions.indexOf(q) + 1;

            this.SetCurrentContext(q.ContextCriterionId);
        }
        else
        {
            this.CurrentContext = this.EvalContexts[0];
        }
    }

    SwitchQuestion(questionId: string)
    {
        this.SetCurrentQuestion(questionId);
        this.VotesRevealed = this.AutoRevealEnabled;
        this.rm.Question = null;

        this.runMeetingQuestionReviewQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId, questionId);
    }


    NextQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            const currentQuestionIndex = this.Questions.findIndex(a => a.QuestionId === this.CurrentQuestionId);
            const nextQuestionIndex = currentQuestionIndex < this.Questions.length - 1 ? currentQuestionIndex + 1 : 0;
            const nextQuestion = this.Questions[nextQuestionIndex];

            this.SwitchQuestion(nextQuestion.QuestionId);

            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    NextUnansweredQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            const currentQuestionIndex = this.Questions.findIndex(q => q.QuestionId === this.CurrentQuestionId);
            const nextQuestions = this.Questions.slice(currentQuestionIndex + 1).concat(this.Questions.slice(0, currentQuestionIndex));
            const nextUnanswered = nextQuestions.find(q => q.Status !== SurveyVoteStatus.Empty);

            if (nextUnanswered)
            {
                this.SwitchQuestion(nextUnanswered.QuestionId);
            }

            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    PreviousQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            const currentQuestionIndex = this.Questions.findIndex(a => a.QuestionId === this.CurrentQuestionId);
            const prevQuestionIndex = currentQuestionIndex > 0 ? currentQuestionIndex - 1 : this.Questions.length - 1;
            const prevQuestion = this.Questions[prevQuestionIndex];

            this.SwitchQuestion(prevQuestion.QuestionId);

            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    AllDoneCommand()
    {
        alert("Thanks! There are no other unanswered questions. You can close this page or continue reviewing your input.");
    }


    showCriterionDetails(name: string, desc: string, path: string)
    {
        this.criterionDetailsDialog.show(name, desc, path);
    }

    showMeetingStarterCommand()
    {
        this.VotesRevealed = false;
        this.AutoRevealEnabled = false;
        this.NamesRevealed = true;

        this.meetingStarterOpened = true;
    }

    ShowAccessLinksCommand()
    {
        this.runCriteriaAccessLinksBySurveyIdQueryV1(this.workspaceId, this.surveyId);
        this.criteriaSurveyAccessLinks.show(this.surveyId);
    }

    showDisagreementsReport()
    {
        this.rm.DisagreementReport = null;
        this.disagreementsReportOpened = true;
        this.runPanelDisagreementsQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    showConsistencyAnalysis()
    {
        this.rm.ConsistencyAnalysis = null;
        this.consistencyAnalysisOpened = true;
        this.runPanelConsistencyAnalysisQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    showCriteriaSurveyEmailSender(surveyId: number, ids: number[])
    {
        this.criteriaSurveyEmailSender.show(this.surveyId, ids);
    }


    ToggleAutoRevealCommand()
    {
        this.AutoRevealEnabled = !this.AutoRevealEnabled;

        if (this.AutoRevealEnabled && !this.VotesRevealed)
        {
            this.VotesRevealed = true;
            this.publishQuestionVotes();
        }
    }

    ToggleNamesRevealedCommand()
    {
        this.NamesRevealed = !this.NamesRevealed;
        this.publishQuestionVotes();
    }

    ToggleVotesRevealedCommand()
    {
        this.VotesRevealed = !this.VotesRevealed;

        if (!this.VotesRevealed && this.AutoRevealEnabled)
        {
            this.AutoRevealEnabled = false;
        }

        this.publishQuestionVotes();
    }



    SetVotesBrowserValue(questionId: string, projectUserId: number, value: number | null)
    {
        if (this.Question?.Id === questionId)
        {
            this.Question.VotesEntries.find(a => a.ProjectUserId === projectUserId).Value = value;

            const currQuestion = this.Questions.find(q => q.QuestionId === questionId);

            if (this.Question.VotesEntries.some(v => v.Value != null))
            {
                if (currQuestion.Status === SurveyVoteStatus.Empty)
                {
                    currQuestion.Status = SurveyVoteStatus.Agg;
                }
            }
            else
            {
                if (currQuestion.Status === SurveyVoteStatus.Agg)
                {
                    currQuestion.Status = SurveyVoteStatus.Empty;
                }
            }
        }
    }

    SetVotesBrowserComment(questionId: string, projectUserId: number, comment: string)
    {
        if (this.Question?.Id === questionId)
        {
            this.Question.VotesEntries.find(a => a.ProjectUserId === projectUserId).Comment = comment;
        }
    }



    handleShowDisagreementsQuestion(questionId: string)
    {
        this.SwitchQuestion(questionId);
        this.disagreementsReportOpened = false;
    }

    handleShowInconsistentQuestion(questionId: string)
    {
        this.SwitchQuestion(questionId);
        this.consistencyAnalysisOpened = false;
    }

    handleStopMeetingCommand() 
    {
        this.MeetingStarted = false;
        this.publishMeetingStatus();
        this.meetingStopperOpened = false;
    }

    handleStartMeetingCommand() 
    {
        this.VotesRevealed = this.AutoRevealEnabled;
        this.MeetingStarted = true;
        this.publishMeetingStatus();
        this.meetingStarterOpened = false;
    }

    handleDownloadAccessLinks(surveyId: number)
    {
        this.runExportAccessLinksBySurveyIdQueryV1(this.workspaceId, surveyId);
    }

    handleStopSurveyCommand() 
    {
        this.invokeStopSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    handleStartSurveyCommand() 
    {
        this.invokeStartSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    handleSendEmailCommand(emailSubject: string, emailBody: string)
    {
        const sender = this.criteriaSurveyEmailSender;
        this.invokeSendEmailCommandV1(this.workspaceId, sender.surveyId, sender.projectUserIds, emailSubject, emailBody);
    }

    handleSavePanelVoteCommand(value: number)
    {
        this.Question.Value = value;
        this.invokeSavePanelVoteCommandV1(this.workspaceId, this.surveyId, this.Question.Id, this.Question.Value, this.Question.Comment);
    }

    handleSavePanelVoteCommentCommand(comment: string)
    {
        this.Question.Comment = comment;

        if (this.SavingCommentHandle == null)
        {
            this.SavingCommentHandle = setTimeout(() =>
            {
                this.invokeSavePanelVoteCommentCommandV1(this.workspaceId, this.surveyId, this.Question.Id, comment);
                this.SavingCommentHandle = null;
            }, 1000);
        }
    }


    mounted()
    {
        this.handler = rt.subscribeModule("CriteriaSurveys.MeetingManager",
            {
                PublishMeetingStatus: (data: any) =>
                {
                    if (this != null)
                    {
                        this.publishMeetingStatus();
                    }
                },
                UpdatePanelistVoteValue: (data: any) =>
                {
                    if (this != null)
                    {
                        this.SetVotesBrowserValue(data.QuestionId, data.ProjectUserId, data.Value);
                        this.publishPanelistVote(data.ProjectUserId, data.QuestionId);
                    }
                },
                UpdatePanelistVoteComment: (data: any) =>
                {
                    if (this != null)
                    {
                        this.SetVotesBrowserComment(data.QuestionId, data.ProjectUserId, data.Comment);
                        this.publishPanelistVote(data.ProjectUserId, data.QuestionId);
                    }
                },
            });

        this.runMeetingManagerPageQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "MeetingManagerPageReadModel")
        {
            this.rm = model as MeetingManagerPageReadModel;

            this.EvalContexts = this.rm.Criteria.sort((a, b) => strCompareLowerCase(a.Path, b.Path));

            this.SetCurrentQuestion(this.rm.Question?.Id);

            this.initialized = true;
        }
        else if (modelName == "MeetingQuestionReviewReadModel")
        {
            this.rm.Question = model as MeetingQuestionReviewReadModel;
            this.publishQuestion();
        }
        else if (modelName == "PanelDisagreementsReportReadModel")
        {
            this.rm.DisagreementReport = model as PanelDisagreementsReportReadModel;
        }
        else if (modelName == "PanelConsistencyAnalysisReadModel")
        {
            this.rm.ConsistencyAnalysis = model as PanelConsistencyAnalysisReadModel;
        }
        else if (modelName == "CriteriaSurveyPanelistsReadModel")
        {
            const rm = model as CriteriaSurveyPanelistsReadModel;
            this.criteriaSurveyAccessLinks.setData(rm);
        }
        else if (modelName === "CriteriaDownloadAccessLinksReadModel")
        {
            const rm = model as CriteriaDownloadAccessLinksReadModel;
            DownloadBlob(rm.Url);
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (StartSurveyCommandV1.matchType(cmd))
        {
            this.rm.SurveyStarted = true;
            this.surveyOpenerOpened = false;
        }
        else if (StopSurveyCommandV1.matchType(cmd))
        {
            this.rm.SurveyStarted = false;
            this.surveyCloserOpened = false;
        }
        else if (SavePanelVoteCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as SavePanelVoteCommandV1;

            if (this.Question.Id === cmd1.QuestionId)
            {
                const q = this.rm.Questions.find(a => a.QuestionId === this.Question.Id);

                if (cmd1.VoteValue != null)
                {
                    q.Status = SurveyVoteStatus.Manual;
                }
                else if (this.Question.VotesEntries.some(a => a.Value != null)) 
                {
                    q.Status = SurveyVoteStatus.Agg;
                }
                else
                {
                    q.Status = SurveyVoteStatus.Empty;
                }
            }
        }
        else if (SendEmailCommandV1.matchType(cmd))
        {
            alert("Sent");
            this.criteriaSurveyEmailSender.close();
        }
    }


    publishMeetingStatus()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("CriteriaSurveys.MeetingManager", "PublishMeetingStarted",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }

        if (this.MeetingStarted === false)
        {
            rt.send("CriteriaSurveys.MeetingManager", "PublishMeetingStopped",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                });
        }
    }

    publishQuestion()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("CriteriaSurveys.MeetingManager", "PublishMeetingQuestion",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }
    }

    publishQuestionVotes()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("CriteriaSurveys.MeetingManager", "PublishMeetingQuestionVotes",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }
    }

    publishPanelistVote(projectUserId: number, questionId: string)
    {
        if (this.MeetingStarted === true && this.VotesRevealed === true && this.Question.Id === questionId)
        {
            const vote = this.Question.VotesEntries.find(a => a.ProjectUserId === projectUserId);

            rt.send("CriteriaSurveys.MeetingManager", "PublishMeetingPanelistVote",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    ProjectUserId: projectUserId,
                    QuestionId: questionId,
                    VoteValue: vote?.Value,
                    VoteComment: vote?.Comment,
                });
        }
    }

    beforeDestroy()
    {
        if (this.handler)
        {
            rt.unsubscribe(this.handler);
        }
    }
}


function compareQuestions(a: CriteriaQuestionsBrowserItemReadModel, b: CriteriaQuestionsBrowserItemReadModel)
{
    return strCompareLowerCase(a.ContextCriterionPath, b.ContextCriterionPath) ||
        strCompareLowerCase(a.FirstCriterionName, b.FirstCriterionName) ||
        strCompareLowerCase(a.SecondCriterionName, b.SecondCriterionName);
}